import datafeedService from "@/stores/dataManager/apiServices/datafeedService"
import ToastUtil from "@/views/components/Toast/Toast"
import { ResponseSuccess } from "../masterTransManager/masterTransManager"
import { useAppSelector } from "@/stores/dataStore/reduxStore/hook"
import i18next from 'i18next';

export const getInstrumentsBySymbolsNoSave = async (param: { config?: object, symbols: any }) => {
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await datafeedService.getInstrumentsBySymbols(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: data,
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getInstrumentsBySymbolsNoSave'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getQuoteSymbolNoSave = async (param: { config?: object, symbols: any }) => {
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await datafeedService.getQuoteSymbol(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: data,
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getQuoteSymbolNoSave'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const useInstrumentsDynamicDict = () => {
    try {
        const instrumentsDynamicDict = useAppSelector((state) => state.symbol.instrumentsDynamicDict)
        return {
            instrumentsDynamicDict
        };
    } catch (e) {
        return {
            instrumentsDynamicDict: {},
        };
    }
}